// 一个比较完整的用例
import GalEngine from 'mihoyo-galgame-engine';
// 默认样式，可以自己覆盖
import 'mihoyo-galgame-engine/dist/theme/default.scss';
import xml from '../../resources/xml';

export default {
  /**
   * 统一的渲染入口，方法名固定，不要更改
   */

  restartScene: 0,

  render() {
    const gal = GalEngine.createAVG({
      stage: 'gal', // 要挂载的dom节点id
      data: xml.chapterXML, // 章节xml，字符串或者dom
      resource: xml.resourceXML, // 资源xml，字符串或者dom
      saveDataName: 'gal_demo', // 存档名5
      useTransformZ: true,
      calcPx(px) {
        // 对引擎内涉及到px计算的部分做换算处理
        return `${px / 100}rem`;
      },
      onEvent: (name, val) => {
        if (name === 'dead') {
          this.restartScene = val;
          document.getElementById('fail').style.display = 'block';
        } else if (name === 'finish') {
          document.getElementById('success').style.display = 'block';
        }
      }
    });
    gal.preload(
      (resource, progress) => {
        document.getElementById('progress-word').innerText = `${progress}%`;
      },
      () => {
        // 预加载全部完成时做一些处理，比如隐藏loading遮罩
        document.getElementById('progress').style.display = 'none';
        gal.start();
      }
    );
    this.events(gal);
  },
  /**
   * 视图事件集中绑定
   */
  events(gal) {
    const download = () => {
      // window.open('https://app.adjust.com/j9sfwtv?campaign=himeko', '_blank'); //tw
      // window.open('https://app.adjust.com/o6qnyau?campaign=Himeko0718&fallback=https%3A%2F%2Fmanga.honkaiimpact3.com%2F', '_blank'); //sea
      window.open('https://app.adjust.com/ao6z3kk?campaign=himeko&fallback=http%3A%2F%2Fwww.global.honkaiimpact3.com%2F', '_blank'); //glb
    }
    document.getElementById('download').addEventListener('click', download);
    document.getElementById('sd').addEventListener('click', download);
    document.getElementById('fd').addEventListener('click', download);
    document.getElementById('fr').addEventListener('click', () => {
      document.getElementById('fail').style.display = 'none';
      gal.start(this.restartScene);
    });
  }
}


